<style>
	.bd-callout {
	    padding: 1.25rem;
	    margin-top: 1.25rem;
	    margin-bottom: 1.25rem;
	    border: 1px solid #eee;
	    border-left-width: .25rem;
	    border-left-color: #1e293d;
	    background: #fff;
      font-size: 16px;
	}
	.bd-callout p:last-child {
	    margin-bottom: 0;
	}
</style>

<template>
	<div class="bd-callout">
		<slot></slot>
	</div>
</template>

<script>
	export default {

	}
</script>